<div class="support-dashboard-container">

  <!-- 🔹 Date Filter (TOP) -->
  <div class="support-dashboard-filter support-dashboard-filter-row">
    <div class="support-dashboard-filter-group support-dashboard-organization-filter">
      <label style="margin-top:8px;">Organizations&nbsp;&nbsp;</label>
      <ng-select
        class="support-dashboard-organization-select"
        [items]="organizationOptions"
        bindLabel="name"
        bindValue="id"
        [clearable]="true"
        [searchable]="true"
        [loading]="loadingOrganizations"
        [placeholder]="loadingOrganizations ? 'Loading organizations...' : 'All Organizations'"
        [ngModel]="selectedOrganization || null"
        (change)="onOrganizationSelectionChange($event)"
      >
        <ng-template ng-option-tmp let-item="item">
          <div class="support-dashboard-assignee-option">
            <span>{{ item.name }}</span>
            <small>{{ item.ticketCount }}</small>
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div class="support-dashboard-filter-group">
      <label>Tickets Between&nbsp;&nbsp;</label>
      <input
        type="text"
        class="datetimepicker"
        [(ngModel)]="dateRange"
      />
    </div>

    <div class="support-dashboard-filter-group support-dashboard-assignee-filter">
      <label style="margin-top:8px;">Assignees&nbsp;&nbsp;</label>
      <ng-select
        class="support-dashboard-assignee-select"
        [items]="assigneeOptions"
        bindLabel="name"
        bindValue="id"
        [multiple]="true"
        [closeOnSelect]="false"
        [hideSelected]="false"
        [clearable]="true"
        [searchable]="true"
        [loading]="loadingAssignees"
        [placeholder]="loadingAssignees ? 'Loading assignees...' : 'All Assignees'"
        [ngModel]="selectedAssignees"
        (change)="onAssigneeSelectionChange($event)"
      >
        <ng-template ng-header-tmp>
          <div
            class="support-dashboard-select-all"
            (click)="selectAllAssignees(); $event.stopPropagation()"
          >
            <input
              type="checkbox"
              [checked]="allAssigneesSelected"
              [indeterminate]="hasAssigneeFilter"
              tabindex="-1"
            />
            <span>Select All</span>
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div class="support-dashboard-assignee-option">
            <span>{{ item.name }}</span>
            <small>{{ item.ticketCount }}</small>
          </div>
        </ng-template>

        <ng-template ng-multi-label-tmp let-items="items">
          <div class="support-dashboard-assignee-summary">
            {{ selectedAssigneeSummary }}
          </div>
        </ng-template>
      </ng-select>
    </div>

    <app-support-dashboard-download
      [disabled]="isDownloadDisabled"
      [exportData]="downloadExportData"
      [preparePdfCharts]="prepareDownloadCharts"
      [getChartImageUrl]="getDownloadChartImageUrl"
    ></app-support-dashboard-download>
  </div>

  <!-- 🔹 Main Header 1-->
  <div class="support-dashboard-card">
    <h2>SUPPORT ANALYTICS TICKETS DASHBOARD</h2>
  </div>

  <!-- 🔹 Summary Header -->
  <div class="summary-header">
    <div class="summary-item">
      <div class="summary-label">Total Tickets</div>
      <div class="summary-value">
        <a
          class="nav-link support-value-link summary-value-link"
          [routerLink]="getMetricRoute('total-tickets')"
          [queryParams]="supportDetailQueryParams"
        >
          {{ totalTickets }}
        </a>
      </div>
    </div>

    <div class="summary-item">
      <div class="summary-label">Resolution SLA</div>
      <div
        [class.summary-value-loading]="loadingSlaSummaryCards"
      >
        <ng-container *ngIf="loadingSlaSummaryCards; else resolutionSlaValue">
          <img
            src="../assets/img/loading_2.svg"
            alt="loading resolution SLA"
            class="summary-loader-icon"
          />
        </ng-container>
        <ng-template #resolutionSlaValue>{{ resolutionSLA }}</ng-template>
      </div>
    </div>

    <div class="summary-item">
      <div class="summary-label">Response SLA</div>
      <div
        [class.summary-value-loading]="loadingSlaSummaryCards"
      >
        <ng-container *ngIf="loadingSlaSummaryCards; else responseSlaValue">
          <img
            src="../assets/img/loading_2.svg"
            alt="loading response SLA"
            class="summary-loader-icon"
          />
        </ng-container>
        <ng-template #responseSlaValue>{{ responseSLA }}</ng-template>
      </div>
    </div>

    <!--
    <div class="summary-item">
      <div class="summary-label">Avg MTTR</div>
      <div class="summary-value">{{ avgMTTR }} hrs</div>
    </div>
    -->
  </div>

  <!-- 🔹 Main Header 2 -->
  <div class="support-dashboard-card">
    <h2>JIRA TICKETS DASHBOARD</h2>
  </div>

  <!-- 🔹 1. Volume by Priority -->
  <div class="table-section">
    <div class="section-title">VOLUME BY PRIORITY</div>
    <div class="table-content-shell">
      <table>
        <thead>
          <tr>
            <th>Priority</th>
            <th>Count</th>
            <th>Percentage</th>
          </tr>
        </thead>
        <tbody *ngIf="volumeByPriorityTableState.loading">
          <tr>
            <td colspan="3" class="section-loading-cell">
              <img
                src="../assets/img/loading_2.svg"
                alt="loading volume by priority"
                class="support-dashboard-loader-icon"
              />
              Loading volume by priority...
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!volumeByPriorityTableState.loading && volumeData.length">
          <tr *ngFor="let row of volumeData"
              [ngClass]="row.priority?.toLowerCase()">
            <td>{{ row.priority }}</td>
            <td><a 
                class="nav-link support-value-link"
                [routerLink]="getPriorityMetricRoute()"
                [queryParams]="getPriorityDetailQueryParams(row.priority)">
                {{ row.count }}</a>
            </td>
            <td>{{ row.percentage.display }}</td>
          </tr>

          <tr class="total">
            <td>Total</td>
            <td>{{ totalTickets }}</td>
            <td>100%</td>
          </tr>
        </tbody>
        <tbody *ngIf="!volumeByPriorityTableState.loading && !volumeData.length">
          <tr>
            <td colspan="3" class="section-empty-cell">No Data Found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- 🔹 2. SLA Compliance Overall -->
  <div class="table-section">
    <div class="section-title">SLA COMPLIANCE - OVERALL</div>
    <div class="table-content-shell">
      <table>
        <thead>
          <tr>
            <th>SLA Type</th>
            <th>Met</th>
            <th>Breached</th>
            <th>Total</th>
            <th>Compliance %</th>
          </tr>
        </thead>
        <tbody *ngIf="slaComplianceOverallTableState.loading">
          <tr>
            <td colspan="5" class="section-loading-cell">
              <img
                src="../assets/img/loading_2.svg"
                alt="loading SLA compliance overall"
                class="support-dashboard-loader-icon"
              />
              Loading SLA compliance overall...
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!slaComplianceOverallTableState.loading && slaOverallData.length">
          <tr *ngFor="let row of slaOverallData">
            <td>{{ row.sla_type }}</td>
            <td>
              <a
                class="nav-link support-value-link"
                [routerLink]="getSlaMetricRoute(row.sla_type, 'met')"
                [queryParams]="supportDetailQueryParams"
              >
                {{ row.met }}
              </a>
            </td>
            <td>
              <a
                class="nav-link support-value-link"
                [routerLink]="getSlaMetricRoute(row.sla_type, 'breached')"
                [queryParams]="supportDetailQueryParams"
              >
                {{ row.breached }}
              </a>
            </td>
            <td>{{ row.total }}</td>
            <td class="compliance-cell">
              {{ row.compliance_percentage.display }}
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!slaComplianceOverallTableState.loading && !slaOverallData.length">
          <tr>
            <td colspan="5" class="section-empty-cell">No Data Found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- 🔹 3. SLA Compliance by Priority -->
  <div class="table-section">
    <div class="section-title">SLA COMPLIANCE BY PRIORITY</div>
    <div class="table-content-shell">
      <table>
        <thead>
          <tr>
            <th>Priority</th>
            <th>Resolution Met</th>
            <th>Resolution Breached</th>
            <th>Resolution %</th>
            <th>Response Met</th>
            <th>Response Breached</th>
            <th>Response %</th>
          </tr>
        </thead>
        <tbody *ngIf="slaComplianceByPriorityTableState.loading">
          <tr>
            <td colspan="7" class="section-loading-cell">
              <img
                src="../assets/img/loading_2.svg"
                alt="loading SLA compliance by priority"
                class="support-dashboard-loader-icon"
              />
              Loading SLA compliance by priority...
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!slaComplianceByPriorityTableState.loading && slaPriorityData.length">
          <tr *ngFor="let row of slaPriorityData"
              [ngClass]="row.priority?.toLowerCase()">
            <td>{{ row.priority }}</td>
            <td>
              <a
                class="nav-link support-value-link"
                [routerLink]="getSlaPriorityMetricRoute()"
                [queryParams]="getSlaPriorityDetailQueryParams(row.priority, 'time_to_resolution', 'met')"
              >
                {{ row.resolution_met }}
              </a>
            </td>
            <td>
              <a
                class="nav-link support-value-link"
                [routerLink]="getSlaPriorityMetricRoute()"
                [queryParams]="getSlaPriorityDetailQueryParams(row.priority, 'time_to_resolution', 'breached')"
              >
                {{ row.resolution_breached }}
              </a>
            </td>
            <td>{{ row.resolution_percentage.display }}</td>
            <td>
              <a
                class="nav-link support-value-link"
                [routerLink]="getSlaPriorityMetricRoute()"
                [queryParams]="getSlaPriorityDetailQueryParams(row.priority, 'time_to_first_response', 'met')"
              >
                {{ row.response_met }}
              </a>
            </td>
            <td>
              <a
                class="nav-link support-value-link"
                [routerLink]="getSlaPriorityMetricRoute()"
                [queryParams]="getSlaPriorityDetailQueryParams(row.priority, 'time_to_first_response', 'breached')"
              >
                {{ row.response_breached }}
              </a>
            </td>
            <td>{{ row.response_percentage.display }}</td>
          </tr>

          <tr class="total">
            <td>Total</td>
            <td>{{ slaPriorityTotal.resolution_met }}</td>
            <td>{{ slaPriorityTotal.resolution_breached }}</td>
            <td>{{ slaPriorityTotal.resolution_percentage.display }}</td>
            <td>{{ slaPriorityTotal.response_met }}</td>
            <td>{{ slaPriorityTotal.response_breached }}</td>
            <td>{{ slaPriorityTotal.response_percentage.display }}</td>
          </tr>
        </tbody>
        <tbody *ngIf="!slaComplianceByPriorityTableState.loading && !slaPriorityData.length">
          <tr>
            <td colspan="7" class="section-empty-cell">No Data Found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- 🔹 4. MTTR -->
  <!-- <div class="table-section">
    <div class="section-title">MTTR BY PRIORITY</div>
    <div class="table-content-shell">
      <table>
        <thead>
          <tr>
            <th>Priority</th>
            <th>Avg Resolution Time (Hours)</th>
            <th>Ticket Count</th>
          </tr>
        </thead>
        <tbody *ngIf="mttrByPriorityTableState.loading">
          <tr>
            <td colspan="3" class="section-loading-cell">
              <img
                src="../assets/img/loading_2.svg"
                alt="loading MTTR by priority"
                class="support-dashboard-loader-icon"
              />
              Loading MTTR by priority...
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!mttrByPriorityTableState.loading && mttrData.length">
          <tr *ngFor="let row of mttrData"
              [ngClass]="row.priority?.toLowerCase()">
            <td>{{ row.priority }}</td>
            <td>{{ row.avg_resolution_time_hours ?? '-' }}</td>
            <td>{{ row.ticket_count }}</td>
          </tr>

          <tr class="total">
            <td>Overall</td>
            <td>{{ mttrOverall.avg_resolution_time_hours }}</td>
            <td>{{ mttrOverall.ticket_count }}</td>
          </tr>
        </tbody>
        <tbody *ngIf="!mttrByPriorityTableState.loading && !mttrData.length">
          <tr>
            <td colspan="3" class="section-empty-cell">No Data Found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div> -->

  <!-- 🔹 5. Tickets by Creation Time -->
  <div class="table-section">
    <div class="section-title">TICKETS BY CREATION TIME</div>
    <div class="table-content-shell">
      <table>
        <thead>
          <tr>
            <th>Time Period</th>
            <th>Ticket Count</th>
            <th>Percentage</th>
          </tr>
        </thead>
        <tbody *ngIf="ticketsByCreationTimeTableState.loading">
          <tr>
            <td colspan="3" class="section-loading-cell">
              <img
                src="../assets/img/loading_2.svg"
                alt="loading tickets by creation time"
                class="support-dashboard-loader-icon"
              />
              Loading tickets by creation time...
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!ticketsByCreationTimeTableState.loading && creationTimeData.length">
          <tr *ngFor="let row of creationTimeData; let isLast = last"
              [ngClass]="{'total': isLast}">
            <td>{{ row.time_period }}</td>
            <td>
              <a
                *ngIf="isCreationTimeMetricLinkable(row.time_period); else creationTimeTicketCount"
                class="nav-link support-value-link"
                [routerLink]="getCreationTimeMetricRoute(row.time_period)"
                [queryParams]="supportDetailQueryParams"
              >
                {{ row.ticket_count }}
              </a>
              <ng-template #creationTimeTicketCount>
                {{ row.ticket_count }}
              </ng-template>
            </td>
            <td>{{ row.percentage.display }}</td>
          </tr>
        </tbody>
        <tbody *ngIf="!ticketsByCreationTimeTableState.loading && !creationTimeData.length">
          <tr>
            <td colspan="3" class="section-empty-cell">No Data Found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- 🔹 Dashboard Charts -->
  <div class="charts-section">
    <div class="section-title">DASHBOARD CHARTS</div>
    <div class="charts-grid">
      <div class="chart-panel" [ngClass]="{ loading: volumeByPriorityTableState.loading }">
        <div #volumeByPriorityChart class="support-chart"></div>
        <div class="loading-image-container" *ngIf="volumeByPriorityTableState.loading">
          <img src="../assets/img/loading_2.svg" alt="loading volume by priority chart" />
          <span>Loading chart...</span>
        </div>
      </div>

      <div class="chart-panel" [ngClass]="{ loading: slaComplianceOverallTableState.loading }">
        <div #slaComplianceOverallChart class="support-chart"></div>
        <div class="loading-image-container" *ngIf="slaComplianceOverallTableState.loading">
          <img src="../assets/img/loading_2.svg" alt="loading SLA compliance overall chart" />
          <span>Loading chart...</span>
        </div>
      </div>

      <div class="chart-panel" [ngClass]="{ loading: slaComplianceByPriorityTableState.loading }">
        <div #slaComplianceByPriorityChart class="support-chart"></div>
        <div class="loading-image-container" *ngIf="slaComplianceByPriorityTableState.loading">
          <img src="../assets/img/loading_2.svg" alt="loading SLA compliance by priority chart" />
          <span>Loading chart...</span>
        </div>
      </div>

      <!-- <div class="chart-panel" [ngClass]="{ loading: mttrByPriorityTableState.loading }">
        <div #mttrByPriorityChart class="support-chart"></div>
        <div class="loading-image-container" *ngIf="mttrByPriorityTableState.loading">
          <img src="../assets/img/loading_2.svg" alt="loading MTTR by priority chart" />
          <span>Loading chart...</span>
        </div>
      </div> -->

      <div class="chart-panel" [ngClass]="{ loading: ticketsByCreationTimeTableState.loading }">
        <div #ticketsByCreationTimeChart class="support-chart"></div>
        <div class="loading-image-container" *ngIf="ticketsByCreationTimeTableState.loading">
          <img src="../assets/img/loading_2.svg" alt="loading tickets by creation time chart" />
          <span>Loading chart...</span>
        </div>
      </div>
    </div>
  </div>

</div>
